export const clearLocalStorage = () => {
  localStorage.clear();
};
